/**
 * main.ts — entry point. Imports the stylesheet, then initialises the three
 * interactive sections (1. Linear Regression is static prose + SVG, no JS).
 *
 * Each section module owns its canvas/slider/button elements by ID and is
 * self-contained; main.ts just kicks them off after the DOM is parsed.
 */

import './style.css';
import { initDerivative } from './derivative';
import { initPartial } from './partial';
import { initGradient } from './gradient';

/**
 * Each section initialiser is isolated so a failure in one (e.g. a missing
 * element on a stripped page, or WebGL unavailable in `initPartial`) can't
 * prevent the others from wiring up. Errors are logged to the console but not
 * re-thrown — the demo is four independent sections, not a transaction.
 */
function boot(): void {
  const init = (name: string, fn: () => void): void => {
    try {
      fn();
    } catch (err) {
      console.error(`[main] ${name} failed to init:`, err);
    }
  };
  init('derivative', initDerivative);
  init('partial', initPartial);
  init('gradient', initGradient);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
